import type { PremiumAchPull, PremiumAchPullInvoice } from '../types'

import { useMutation } from '@tanstack/react-query'
import { Button } from 'antd'
import { useCallback } from 'react'

import $api from '../../../API'
import { pluralize } from '../formatters'

export interface PremiumGroupFooterProps {
  pull: PremiumAchPull
  selected: PremiumAchPullInvoice[]
  onClearSelection: () => void
  onExcludeInvoices: () => void
}

export const PremiumPullFooter = (props: PremiumGroupFooterProps): JSX.Element => {
  // todo - implement in/out interfaces
  const mutation = useMutation<{ id: string }, Error, unknown>({
    mutationFn: async data => {
      try {
        const response = await $api.delete<{ id: string }>('/batch/invoice', {
          headers: {
            'Content-Type': 'application/json'
          },
          data
        })

        return response.data
      } catch {
        throw new Error('Failed to exclude invoices')
      }
    },
    onSuccess: () => {
      props.onExcludeInvoices()
    },
    onError: error => {
      console.error('Failed to exclude invoices:', error)
    }
  })

  const handleExcludeInvoices = useCallback(() => {
    const selected = props.selected
    if (selected[0] !== undefined) {
      mutation.mutate({
        id: props.pull.id,
        invoices: selected.map(i => i.id)
      })
    }
  }, [props.pull, props.selected, mutation])

  return (
    <div className='flex flex-row' style={{ alignItems: 'center' }}>
      <span style={{ fontWeight: 'bold' }}>
        {props.selected.length === 0 ? 'No' : props.selected.length}
        {pluralize(props.selected.length, ' invoice ', ' invoices ')}
        selected
      </span>
      {props.selected.length > 0 ? (
        <a
          href='#'
          className='text-blue-700 text-[14px]'
          style={{ marginLeft: '10px' }}
          onClick={props.onClearSelection}
        >
          Clear selection
        </a>
      ) : null}
      {(props.pull.status === 'initial_review' || props.pull.status === 'on_approve') && (
        <Button
          type='primary'
          danger
          loading={mutation.isLoading}
          className='ml-auto'
          disabled={props.selected.length === 0}
          style={{ visibility: props.selected.length > 0 ? 'visible' : 'hidden' }}
          onClick={handleExcludeInvoices}
        >
          Exclude from this pull
        </Button>
      )}
    </div>
  )
}
